/* unplugin-vue-components disabled */import { render } from "./edit-modal.vue?vue&type=template&id=fe8534fe&scoped=true"
import script from "./edit-modal.vue?vue&type=script&lang=js"
export * from "./edit-modal.vue?vue&type=script&lang=js"

import "./edit-modal.vue?vue&type=style&index=0&id=fe8534fe&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8534fe"],['__file',"src/pages/sh-topics/edit-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe8534fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe8534fe', __exports__)) {
    api.reload('fe8534fe', __exports__)
  }
  
  module.hot.accept("./edit-modal.vue?vue&type=template&id=fe8534fe&scoped=true", () => {
    api.rerender('fe8534fe', render)
  })

}


export default __exports__